// Ported from vlookup-dramatic/app/events/page.tsx by scripts/revamp/port-design.js
// Route: /event/:type  (type = "upcoming" | "past"; see src/Route/route.js RoutesRevamp)
import React from "react";
import { eventsPageV3 } from "../../lib/content";
import { usePageMeta } from "../../hooks/use-page-meta";
import { EventsBrowser } from "./events-browser";

export default function EventsPage(props) {
  const type = props.match && props.match.params && props.match.params.type === "past" ? "past" : "upcoming";
  usePageMeta({
    title: type === "past" ? "Past Events | vLookUp" : "Events | vLookUp",
    description: eventsPageV3.sub,
  });
  return <EventsBrowser type={type} />;
}
